import React from 'react';
import BulkCreateProjectWizard from '../components/createProject/BulkCreateProjectWizard';

const BulkCreateProjectPage: React.FC = () => {
  return <BulkCreateProjectWizard />;
};

export default BulkCreateProjectPage;
